/**
 * Lista de modulos do sistema (sidebar). O id e a chave da pagina (route).
 */
export const MODULOS_LISTA = [
  { id: 'Empresas', label: 'Empresas' },
  { id: 'Agenda', label: 'Agenda' },
  { id: 'Dashboard', label: 'Dashboard' },
  { id: 'Upload', label: 'Novo Edital/Cotação' },
  { id: 'ConsultarEditais', label: 'Consultar Editais' },
  { id: 'Analise', label: 'Análise e Aprovação' },
  { id: 'Licitacao', label: 'Licitação' },
  { id: 'Propostas', label: 'Propostas' },
  { id: 'AtestadosTecnicos', label: 'Atestados Técnicos' },
  { id: 'Historico', label: 'Histórico' },
  { id: 'Contratos', label: 'Contratos' },
  { id: 'Documentos', label: 'Documentos' },
  { id: 'AtestadosDeclaracoes', label: 'Declarações' },
  { id: 'Assina', label: 'Assina' },
  { id: 'AuctionCertify', label: 'AuctionCertify' },
  { id: 'StatusReport', label: 'Status Report' },
  { id: 'Relatorios', label: 'Dashboard Comercial' },
  { id: 'LearnedLessons', label: 'Lições Aprendidas' },
  { id: 'Suporte', label: 'Suporte' },
  { id: 'Manifesto', label: 'Manifesto' },
  { id: 'Social', label: 'Social' },
  { id: 'Pulse', label: 'Pulse — Automação' },
];
